import { xor } from 'lodash';
import PropTypes from 'prop-types';
import React, { useCallback } from 'react';
import { ButtonToolbar, DropdownButton, MenuItem } from 'react-bootstrap';
import { connect } from 'react-redux';
import { selectPortfolios } from '../../modules/portfolio.js';
import { navigateToChangeImpactReports } from '../links/index.jsx';
import { getOrgTermsContent } from '../../content/utils.js';

const mapStateToProps = (state) => {
  const portfolios = selectPortfolios(state);

  return { portfolios };
};

PortfolioFilter.propTypes = {
  portfolios: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number.isRequired,
      name: PropTypes.string.isRequired,
    })
  ),
  selectedPortfolioIds: PropTypes.arrayOf(PropTypes.number),
};

PortfolioFilter.defaultProps = {
  portfolios: [],
  selectedPortfolioIds: [],
};

function PortfolioFilter({ portfolios, selectedPortfolioIds }) {
  const selectedCount = selectedPortfolioIds.length;

  const handleSelect = useCallback(
    (portfolioId) => {
      return navigateToChangeImpactReports({
        portfolioIds:
          portfolioId !== undefined
            ? String(portfolioId).length
              ? xor(selectedPortfolioIds, [portfolioId])
              : []
            : [],
      });
    },
    [selectedPortfolioIds]
  );

  const renderMenuItem = useCallback(
    (portfolio) => (
      <React.Fragment key={portfolio.name ? portfolio.id : 0}>
        <MenuItem
          active={selectedPortfolioIds.includes(
            portfolio.name ? portfolio.id : 0
          )}
          eventKey={portfolio.name ? portfolio.id : 0}
          onSelect={handleSelect}
        >
          {portfolio.name || `No ${getOrgTermsContent('portfolio')}`}
        </MenuItem>
      </React.Fragment>
    ),
    [selectedPortfolioIds]
  );

  return (
    <div className="flex-col report-filter">
      <div className="text-muted filter-label">
        {getOrgTermsContent('portfolio')}
      </div>
      <ButtonToolbar>
        <DropdownButton
          bsStyle="info"
          title={selectedCount ? `${selectedCount} Selected` : 'All'}
          id="portfolios-filter"
          className="btn-block"
          onSelect={handleSelect}
          pullRight
        >
          <MenuItem active={selectedCount === 0}>All</MenuItem>
          {portfolios.map(renderMenuItem)}
          <MenuItem divider />
        </DropdownButton>
      </ButtonToolbar>
    </div>
  );
}

export default connect(mapStateToProps)(PortfolioFilter);
